var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ed-content-section-loading edg-shimmer-container w-100"},_vm._l((_vm.columns),function(index){return _c('span',{key:index,staticClass:"bsx-d-flex w-100 edg-shimmer"})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }